<template>
  <div class="test-content">
     <SortLi v-for="(pep,index) in arr" :content="pep" :key="index" v-on:listenToChildEvent="showMsg"></SortLi>
     <div class="btn-group">
          <button class="default-btn large-btn" v-if="next" @click="toNext">下一题</button>
          <button class="default-btn large-btn submit-btn" v-if="submit" @click="submitDta" v-preventReClick>提交</button>
     </div>
  </div>
</template>
<script>
import SortLi from '../components/SortLi';
import axios from 'axios';
import qs from 'qs';
import setWechatTitle from '@/utils/setWechatTitle.js'
import { mapState } from 'vuex'
export default {
  props: {
    id: Number
  },
  name: 'CareerOrientation',
  components:{
    'SortLi':SortLi,
  },
  data () {
    return {
      arr:[
        {'num':1,'title':'1、我喜欢做的事情是：','show':true,'answer':['能够发挥我的独特性或者创造力的事情','需要亲自动手操作执行，并能直接看到效果的事情','有明确目标与操作方式标准，需要按规定完成的事','需要设身处地考虑并满足他人独特的情感需求的事','需要我来主导的，并发动大家协同一起完成的事情','有深度的分析思考过程的事'],'errorMessage':''},
        {'num':2,'title':'2、我最突出的优势表现为：','show':false,'answer':['擅长做那些需要动手操作、具体有形的事与物','喜欢新异的事，擅长以别出新裁的方式做事情','擅长于倾听他人、乐于助人，有较强的亲和力','擅长说服、调动他人，以实现自己期望的目标','擅长分析推理，以形成合乎逻辑的新发现','对细节敏感，做事追求准确、准时，让人放心'],'errorMessage':''},
        {'num':3,'title':'3、我可能会喜欢的领域是：','show':false,'answer':['哲学、数学、物理、天文','艺术、文学、舞蹈、设计','教育、咨询、救助、公共服务','保险、营销、管理、政治','会计、秘书、编辑、物流仓储','勘探测绘、工程机械、船务、烹饪'],'errorMessage':''},
        {'num':4,'title':'4、我给别人的印象是：（请选择自己较为适合的即可）','show':false,'answer':['乐于助人、合群、对人耐心、善解人意、温暖','直率、注重实际，不喜欢成为众人关注的焦点 ，动手能力强','不守常规、冲动、独创、善表达、敏感、理想','精力旺盛、善出风头、自信、盛气凌人、魅力','理性冷静、睿智、有深刻洞察、慢热、较不合群','谨慎、遵守常规、有效率，按部就班准确完成'],'errorMessage':''},
        {'num':5,'title':'5、我喜欢的做事方式是：','show':false,'answer':['个性化的表达，展现自己的独特之处','运用技术，或者操作机器、工具','有清晰的规范与目标，然后按规则有条理进行','在彼此关心、友爱互助的团队里，配合地做事','以有感染力和鼓动性的方式说服大家一起努力','独立地通过研究、实验获得新发现或解决问题'],'errorMessage':''},
        {'num':6,'title':'6、我比较喜欢的是：','show':false,'answer':['充满好奇地对各种奥秘进行探究','喜欢别致的着装，新颖的色彩与独特的生活','喜欢与人交往，总能在帮助他人获得满足感','喜欢挑战性的事情与目标，愿意冒一定风险','喜欢户外、与自然亲近的、展现体力的活动','喜欢做事情有清晰的计划，好让人心里有底'],'errorMessage':''},
        {'num':7,'title':'7、我自己的能力特长是：','show':false,'answer':['社会与自然科学能力：独自探究解决复杂问题的能力','机械和运动能力：使用工具的能力，善动手与户外活动','人际与社交能力：社交与助人的能力，偏爱融洽的关系','领导和演说能力：影响力，并期待高回报率','艺术和想象能力：创造力，偏爱天马行空','文书和计算能力：明确的计划能力，遵从规则与目标'],'errorMessage':''},
      ],
      next:true,
      submit:false,
      current:1,
      currentAnswer:'',
      result:'',
      submitNum:0
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created(){
    setWechatTitle('生涯驿站-职业倾向测评');
  },
  methods:{
    showMsg(cur,res){
      this.current = cur;
      this.currentAnswer = res;
    },
    toNext(){
        const index = this.currentAnswer.indexOf(6),answerIndex = this.result.indexOf(this.current+'$') ;
        if(index>=0){
          this.arr.map((item)=>{
             if(index!=-1){
                if(item.show){
                item.show=false;
              }
              if(item.num==(this.current+1)){
                  item.show=true;
                  if((this.current+1)==7){
                    this.next=false
                    this.submit=true;
                  }
                }
              }
          })
        }else{
          this.arr[this.current-1].errorMessage = '请按要求进行排序'
        }

        if(index!=-1&&answerIndex==-1){
           this.result+=this.current+"$"+this.currentAnswer;
           if((this.current+1)<=7){
             this.result+="}";
          }
          this.current++
          this.currentAnswer=''
        }
    },
    submitDta(){
      if(this.submitNum==0){
        const index = this.currentAnswer.indexOf(6);
        if(index!=-1&&this.current==7){
           this.result+=this.current+"$"+this.currentAnswer;
           this.current =8
           const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded'},
            data:qs.stringify({
              submitdata: this.result,
              openId: this.shengyaUser.openid
            }),
            url:'/cob/saveCosHollandAnswer.do'
          };
          axios(options)
          .then((response)=>{
            if(response.data.result.success){
              let cosAnswer = response.data
              let shengyaUser = cosAnswer.data.user
              this.$bus.$emit('play-finish', shengyaUser)
            }
          })
          .catch((error)=>{
            console.warn(error);
          });
        }
      }
    }
  }

}
</script>
<style>


</style>
